import React from "react";

import { Row, Col } from "react-flexbox-grid";
import { TextField } from "components/support";
import { observer } from "mobx-react";

import style from "./style";

const EmailConfig = ({ className, company, onChange }) => (
  <Row className={className}>
    <Col xs={12} md={6}>
      <TextField
        rows={5}
        fullWidth
        multiLine
        floatingLabelFixed
        floatingLabelText="Template de email"
        value={company.email_texts.sale_document}
        onChange={(_, value) => onChange("sale_document", value)}
      />
    </Col>
    <Col xs className="template-info">
      <p className="text-justify">
        O template de email é a mensagem que será enviada para os clientes
        quando você selecionar a opção "Enviar por email" após concluir uma
        venda.
      </p>
      <p className="text-justify">
        Caso você utilize algum dos códigos abaixo, eles serão substituídos pela
        legenda. Além disso, você também pode utilizar códigos HTML.
      </p>

      <dl>
        <dt>
          <code>#[nome_do_cliente]</code>
        </dt>
        <dd>Nome do cliente</dd>

        <dt>
          <code>#[nome_da_empresa]</code>
        </dt>
        <dd>Nome fantasia da empresa</dd>

        <dt>
          <code>* </code>
        </dt>
        <dd>Novo parágrafo</dd>
      </dl>
    </Col>
  </Row>
);

export default style(observer(EmailConfig));



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/config-app/email-config/index.jsx